import { render, staticRenderFns } from "./edit-year.vue?vue&type=template&id=b08b5bbc"
import script from "./edit-year.vue?vue&type=script&lang=ts"
export * from "./edit-year.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports